import type { CreateSetup, Setup } from '@hvf/contracts'

export function isSetupLogScale(setup: Setup | CreateSetup) {
	return setup.duration === 'multiday'
}
